/* eslint semi: 1 */

import _ from 'lodash';

/**
 * Method to detect that validators returns validation errors
 */
export function hasErrors (input) {
  if (!_.isArray(input)) {
    return false;
  }

  // if it's array of inputs then go recursive
  return !_.isUndefined(_.find(input, (record) => !_.isEmpty(record) || !record));
}

/**
 * Asynchronously validate an ElementUI form
 */
export async function asyncFormValidation (form) {
  const results = await Promise.all(form.fields.map((field) => {
    return new Promise((resolve, reject) => {
      try {
        field.validate('', resolve);
      } catch (e) {
        console.error('Couldn\'t execute validation rule', e);
        reject(e);
      }
    });
  }));
  return !hasErrors(results);
}

/**
 * Wrapper for Element UI Validation Rule to use it
 * with async functions and write less validation logic leveraing async/await syntax
 * @param {Function} fn - Async function to validate field
 * @returns Element UI Validation Rule function
 */
export function asyncValidationRule (fn) {
  return (rule, value, callback) => {
    (async () => {
      const data = await fn(rule, value);
      callback(data);
    })();
  };
}
